import { Link } from "react-router-dom";

export default function ZtkLogo({ className = "", showText = true, light = false }) {
  return (
    <Link to="/" className={`flex items-center gap-3 ${className}`} data-testid="brand-logo">
      <img
        src="/logo-ztkig.png"
        alt="Związek Telewizji Kablowych w Polsce – Izba Gospodarcza"
        className="h-11 w-auto object-contain"
      />
      {showText && (
        <span className="hidden flex-col leading-none 2xl:flex">
          <span className={`font-display text-sm font-extrabold tracking-tight ${light ? "text-white" : "text-ztk-navy dark:text-white"}`}>
            Związek Telewizji
          </span>
          <span className={`label-mono text-[10px] ${light ? "text-white/70" : "text-ztk-blue"}`}>
            Kablowych
          </span>
        </span>
      )}
    </Link>
  );
}
